import { Card } from '@/components/common/card'
import { Markdown } from '@/components/common/markdown'
import { SeverityIcon } from '@/components/common/severityIcon'
import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'
import { getSeverityClasses } from '@/utils/scoreColors'

interface Props {
  flags: Vault['flags']
}

export const VaultFlags = ({ flags }: Props) => {
  if (!flags || flags.length === 0) return null

  return (
    <section className="flex flex-col gap-4">
      {flags.map((flag, index) => (
        <Card key={index} className={cn('h-fit border p-4 md:px-5', getSeverityClasses(flag.severity))}>
          <div className="flex gap-2">
            <SeverityIcon severity={flag.severity} />
            <Markdown className="min-w-0 break-words text-sm">{flag.content}</Markdown>
          </div>
        </Card>
      ))}
    </section>
  )
}
